// extracted by mini-css-extract-plugin
export default {"fab":"Fab_fab__wOSKW","icon":"Fab_icon__xbth6","text":"Fab_text__vXfrV","compact":"Fab_compact__aSkOj"};